import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';

import {
  IconCheckFilled,
  IconInfoFilled,
  IconCloseFilled,
} from '@prisjakt/ui/icon';

export const Message = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 1;
`;

export const iconStyles = css`
  margin-right: ${layout.measurements.spacing100};
`;

export const Check = styled(IconCheckFilled)`
  ${iconStyles}
`;

export const Info = styled(IconInfoFilled)`
  ${iconStyles}
`;

export const Warning = styled(IconCloseFilled)`
  ${iconStyles}
`;
